module.exports = __webpack_public_path__ + "img/thin-add-button-svgrepo-com.0d785c41.svg";